import React from 'react';

import 'react-date-range/dist/styles.css'; // main style file
import 'react-date-range/dist/theme/default.css';

import 'react-dates/initialize';
import 'react-dates/lib/css/_datepicker.css';

import 'video-react/dist/video-react.css';

import GlobalStyles from 'stylesheets/global';
import ErrorBoundary from 'containers/ErrorBoundary';
import Growl from 'containers/Growl';


const App = ({
  children,
}) => (
  <main>
    <Growl />
    <ErrorBoundary>
      <GlobalStyles />
      {children}
    </ErrorBoundary>
  </main>
);

export default App;
